module.exports = __webpack_public_path__ + "img/phone.4b9a4bbd.png";